module.exports = __webpack_public_path__ + "img/goldLogo.ea71edcd.svg";